export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/pk.281b04af.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};